export default {"src":"/_next/static/media/megaphone-logo.48c36359.svg","height":24,"width":116,"blurWidth":0,"blurHeight":0};